var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"my-2",attrs:{"cols":"12"}},[_c('v-alert',{attrs:{"outlined":"","type":_vm.alertType},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }